import type { ApiService } from "@/domains/api/api-service"

import type { IGaugeApiTransport } from "./interfaces"
import type { GaugeApiData } from "./types"

export class GaugeApiTransport implements IGaugeApiTransport {
  constructor(private readonly apiService: ApiService) {}

  async loadGaugeBribes(): Promise<Record<string, GaugeApiData>> {
    const items = await this.apiService.getGaugeBribes()

    if (typeof items !== "object") {
      throw new Error("Invalid response shape")
    }

    return items
  }
}
